export default function isAdmin(user) {
  return user.roles.length && user.roles[0].role_name === "system_admin";
}
